// import withReducer from 'store/withReducer'
import {WithPatientFile} from './container'
// import reducer from './module'

export default  WithPatientFile
